<ul class="nav nav-pills nav-justified">
  <li *ngFor="let tab of shopService.getTabGroupTabs(ctx)" class="nav-item pointer mx-2" (click)="shopService.startShopModule(ctx, tab)">
    <span class="nav-link" [ngClass]="{'active': tab.ID === shopService.currentActiveShop}">{{tab.Naam}}</span>
  </li>
</ul>